import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from '@angular/router';


import { ApiAuthService } from '@services/api-auth.service';

@Injectable()
export class CanActivateAuthGuard  {

    constructor(private router: Router, private apiAuthService: ApiAuthService) { }
    
    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | Promise<boolean | UrlTree> {
        // Check if exist stored session.
        const session = this.apiAuthService.getSession();
        if (session && session.user) {

            return this.apiAuthService.getEnvVariables().then(_ => true, _ => this.apiAuthService.logout(this.router, true));
        }
        // Regresa a login si no esta en la pagina de logout
        const urls = this.router.url.split('/').filter(x => x); // Filtra las urls no vacías
        if (!urls.some(x => x.indexOf('logout') >= 0)) {
            this.apiAuthService.logout(this.router, true);
        }
        return false;
    }
}

@Injectable()
export class CanActivateRegisterAccountGuard  {

    constructor(private router: Router, private apiAuthService: ApiAuthService) { }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | Promise<boolean | UrlTree> {

        return true;

        // Check if exist stored session.
        // return this.apiAuthService.loadAccount(true).then(
        //     (company: CustomerModel) => {

        //         // Navega a completar la info de cuenta si no se a llenado
        //         if (!company.accountFilledAt) {

        //             return true;
        //         }
        //         // Regresa a login
        //         this.apiAuthService.logout(this.router);
        //         return false;
        //     },
        //     () => {

        //         this.apiAuthService.logout(this.router);
        //         return false;
        //     }
        // );
    }
}
